import MaterialTable from "material-table";
import React, { forwardRef } from "react";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import { Typography } from "@mui/material";

// === Table icons ===
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

// === Render Cell with bold support ===
const renderCell = (data, field) => (
  <div>
    {data?.bold ? (
      <Typography fontSize="0.875rem" fontWeight="600">
        {data?.[field]}
      </Typography>
    ) : (
      <Typography fontSize="0.875rem">{data?.[field]}</Typography>
    )}
  </div>
);

const headerStyle = { fontSize: "1rem" };

// === Mapping API keys to Table Columns ===
// const mapTypeToColumn = {
//   OOREDOO: "Oredoo",
//   VFOM: "Vodafone",
//   RENNA: "Renna",
//   NFND: "Friendi",
//   "": "Other", // 👈 map empty string to Other
// };

// === Transform API Data into Table Format ===
// const transformData = (rawData) => {
//   if (!rawData || typeof rawData !== "object") return []; // safety check

//   const result = [];

//   // Totals row
//   const totals = {
//     plan: "Total",
//     Oredoo: 0,
//     Vodafone: 0,
//     Renna: 0,
//     Friendi: 0,
//     Other: 0,
//     sub_total: 0,
//     bold: true,
//   };

//   Object.keys(rawData).forEach((planKey) => {
//     if (["total", "createdAt", "modifiedAt"].includes(planKey)) return;

//     const planData = rawData[planKey] || {}; // 👈 ensure it's always object

//     const row = {
//       plan: planKey,
//       Oredoo: 0,
//       Vodafone: 0,
//       Renna: 0,
//       Friendi: 0,
//       Other: 0,
//       sub_total: planData.count ?? 0,
//       bold: false,
//     };

//     // 👇 protect against missing or null "types"
//     Object.entries(planData.types || {}).forEach(([typeKey, typeData]) => {
//       const columnName = mapTypeToColumn[typeKey] || "Other";
//       const count = typeData?.count ?? 0;
//       row[columnName] += count;
//       totals[columnName] += count;
//     });

//     totals.sub_total += planData.count ?? 0;

//     result.push(row);
//   });

//   // Push totals row at the end
//   if (result.length > 0) result.push(totals);

//   return result;
// };

// === Table Component ===
const MnpPlansTable = ({ data, type }) => {
  const renderCell = (data, field) => {
    const value = data?.[field] ?? 0;
    return (
      <div>
        {data?.bold ? (
          <Typography fontSize="0.875rem" fontWeight="600">
            {value}
          </Typography>
        ) : (
          <Typography fontSize="0.875rem">{value}</Typography>
        )}
      </div>
    );
  };

  // Check if "Other" column has any non-zero value
  const showOther = data?.some((row) => (row[""] ?? 0) > 0);

  // Build columns array
  const columns = [
    {
      title: `Plans ${type}`,
      field: "plan",
      headerStyle,
      render: (d) => renderCell(d, "plan"),
    },
    {
      title: "Oredoo",
      field: "OOREDOO",
      headerStyle,
      render: (d) => renderCell(d, "OOREDOO"),
    },
    {
      title: "Vodafone",
      field: "VFOM",
      headerStyle,
      render: (d) => renderCell(d, "VFOM"),
    },
    {
      title: "Renna",
      field: "RENNA",
      headerStyle,
      render: (d) => renderCell(d, "RENNA"),
    },
    {
      title: "Friendi",
      field: "NFND",
      headerStyle,
      render: (d) => renderCell(d, "NFND"),
    },
    showOther && {
      title: "Other",
      field: "",
      headerStyle,
      render: (d) => renderCell(d, ""),
    },
    {
      title: "Sub Total",
      field: "sub_total",
      headerStyle,
      render: (d) => renderCell(d, "sub_total"),
    },
  ].filter(Boolean); // filter(Boolean) removes false/null (when showOther is false)

  return (
    <div style={{ width: "100%", height: "auto", direction: "ltr" }}>
      <MaterialTable
        icons={tableIcons}
        columns={columns}
        data={data}
        title={<h2></h2>}
        options={{ search: false }}
      />
    </div>
  );
};

export default MnpPlansTable;
